module.exports = __webpack_public_path__ + "static/buy-black-26b0b852a21b27895b7c34e55b3bea16.png";